/*https://stackoverflow.com/a/30730835*/
/*  removeStorage: removes a key from sessionStorage and its sibling expiracy key
params:
key <string>     : sessionStorage key to remove
returns:
<boolean> : telling if operation succeeded
*/
const removeStorage = (key: string): boolean => {
	try {
		sessionStorage.removeItem(key);
		sessionStorage.removeItem(key + '_expiresIn');
	} catch (e) {
		console.info(
			`removeStorage: Error removing key [${key}] from sessionStorage: ${JSON.stringify(
				e
			)}`
		);
		return false;
	}
	return true;
};
/*  getStorage: retrieves a key from sessionStorage previously set with setStorage().
    params:
        key <string> : sessionStorage key
    returns:
        <string> : value of sessionStorage key
        null : in case of expired key or failure
    */
const getStorage = (key: string): string | null => {
	const now = Date.now(); //epoch time, lets deal only with integer
	// set expiration for storage
	let expiresIn = parseInt(sessionStorage.getItem(key + '_expiresIn'));
	if (expiresIn === undefined || expiresIn === null) {
		expiresIn = 0;
	}

	if (expiresIn < now) {
		// Expired
		removeStorage(key);
		return null;
	} else {
		try {
			const value = sessionStorage.getItem(key);
			return value;
		} catch (e) {
			console.info(
				`getStorage: Error reading key [${key}] from sessionStorage: ${JSON.stringify(
					e
				)}`
			);
			return null;
		}
	}
};
/*  setStorage: writes a key into sessionStorage setting a expire time
    params:
        key <string>     : sessionStorage key
        value <string>   : sessionStorage value
        expires <number> : number of seconds from now to expire the key
    returns:
        <boolean> : telling if operation succeeded
    */
const setStorage = (key: string, value: string, expires: number) => {
	if (expires === undefined || expires === null) {
		expires = 24 * 60 * 60; // default: seconds for 1 day
	} else {
		expires = Math.abs(expires); //make sure it's positive
	}

	const now = Date.now(); //millisecs since epoch time, lets deal only with integer
	const schedule = now + expires * 1000;
	try {
		sessionStorage.setItem(key, value);
		sessionStorage.setItem(key + '_expiresIn', schedule.toString());
	} catch (e) {
		console.info(
			`setStorage: Error setting key [${key}] in sessionStorage: ${JSON.stringify(
				e
			)}`
		);
		return false;
	}
	return true;
};

export { removeStorage, getStorage, setStorage };
